import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

const ACTIONS = [
  { key: 'peut_voir', label: 'Voir' },
  { key: 'peut_creer', label: 'Créer' },
  { key: 'peut_modifier', label: 'Modifier' },
  { key: 'peut_supprimer', label: 'Supprimer' },
];

export default function Permissions() {
  const [pages, setPages] = useState([]);
  const [roles, setRoles] = useState([]);
  const [matrix, setMatrix] = useState({}); // `${role}|${page}` -> row
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/permissions');
      setPages(data.pages || []);
      setRoles(data.roles || []);
      const m = {};
      for (const p of data.permissions) m[`${p.role}|${p.page_id}`] = p;
      setMatrix(m);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const val = (role, page, action) => !!matrix[`${role}|${page}`]?.[action];

  const toggle = async (role, page, action) => {
    const cur = matrix[`${role}|${page}`] || { role, page_id: page, peut_voir: false, peut_creer: false, peut_modifier: false, peut_supprimer: false };
    const body = { ...cur, [action]: !cur[action] };
    setMatrix((m) => ({ ...m, [`${role}|${page}`]: body })); // optimiste
    try { await api.put('/permissions', body); }
    catch { load(); }
  };

  return (
    <div className="page-container">
      <div className="page-header-row">
        <div>
          <h2 className="page-title">Permissions</h2>
          <p className="page-subtitle">Droits d'accès par rôle et par page module</p>
        </div>
      </div>

      {loading ? (
        <div className="table-empty">Chargement…</div>
      ) : pages.length === 0 ? (
        <div className="table-container"><div className="table-empty">
          Aucun module métier actif pour l'instant. La matrice des permissions apparaîtra ici dès qu'un module sera ajouté.
          <br />Les rôles <strong>admin</strong> et <strong>super-admin</strong> ont toujours un accès total.
        </div></div>
      ) : (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Page</th>
                {roles.map((r) => ACTIONS.map((a) => <th key={`${r}-${a.key}`}>{r} · {a.label}</th>))}
              </tr>
            </thead>
            <tbody>
              {pages.map((p) => (
                <tr key={p.id}>
                  <td>{p.icon} {p.label}</td>
                  {roles.map((r) => ACTIONS.map((a) => (
                    <td key={`${r}-${a.key}`} style={{ textAlign: 'center' }}>
                      <input type="checkbox" checked={val(r, p.id, a.key)} onChange={() => toggle(r, p.id, a.key)} />
                    </td>
                  )))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
